import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type AlertState = {
  open: boolean
  message: string
  onClose?: (() => void) | null
}

const initialState: AlertState = {
  open: false,
  message: '',
  onClose: null,
}

type OpenAlertPayload = {
  message: string
  onClose?: () => void
}

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    openAlert: (state, action: PayloadAction<OpenAlertPayload>) => {
      state.open = true
      state.message = action.payload.message
      state.onClose = action.payload.onClose ?? null
    },
    closeAlert: (state) => {
      state.open = false
      state.message = ''
      state.onClose = null
    },
  },
})

export const { openAlert, closeAlert } = alertSlice.actions
export default alertSlice.reducer


